import { create } from 'zustand'

// Lets the Today page chrome (view toggles) know the all-done recap is showing.
export const useTodayAllDoneShown = create<{ shown: boolean; set: (shown: boolean) => void }>(
  (set) => ({ shown: false, set: (shown) => set({ shown }) }),
)
